import { UPDATE_GUIDELINE_GPT_USAGE, UPDATE_MISMO_USAGE, UPDATE_FORM1003_USAGE, UPDATE_SCENARIO_DESK_USAGE, SET_DEFAULT_USE } from "../Defs/subscriptiondefs";

const initState = {
    currentInfo: {},
    showFeedback: false,
    selectedProduct: '',
    selectedFeature: '',
}

export default function subscriptionReducer(state = initState, action) {
    const { type, data } = action
    switch (type) {
        case 'SUBSCRIPTION_INFO': {
            return {
                ...state,
                currentInfo: data,
            }
        }
        case UPDATE_GUIDELINE_GPT_USAGE: {
            return {
                ...state,
                currentInfo: {
                    ...state.currentInfo,
                    usage: {
                        ...state.currentInfo.usage,
                        guidelineGptUsage: action.payload,
                    }
                }
            }
        }
        case UPDATE_SCENARIO_DESK_USAGE: {
            return {
                ...state,
                currentInfo: {
                    ...state.currentInfo,
                    usage: {
                        ...state.currentInfo.usage,
                        scenarioDeskUsage: action.payload,
                    }
                }
            }
        }
        case UPDATE_MISMO_USAGE: {
            return {
                ...state,
                currentInfo: {
                    ...state.currentInfo,
                    usage: {
                        ...state.currentInfo.usage,
                        mismoUsage: action.payload,
                    }
                }
            }
        }
        case UPDATE_FORM1003_USAGE: {
            return {
                ...state,
                currentInfo: {
                    ...state.currentInfo,
                    usage: {
                        ...state.currentInfo.usage,
                        form1003Usage: action.payload,
                    }
                }
            }
        }
        case 'SET_SHOW_FEEDBACK': {
            return {
                ...state,
                showFeedback: action.payload
            }
        }
        case 'SET_SELECTED_PRODUCT': {
            return {
                ...state,
                selectedProduct: action.payload
            }
        }
        case 'SET_SELECTED_FEATURE': {
            return {
                ...state,
                selectedFeature: action.payload
            }
        }
        case SET_DEFAULT_USE : {
            return {
                ...state,
                currentInfo:{
                    ...state.currentInfo,
                    usage: {
                        ...state.currentInfo.usage,
                        ...action.payload
                    }
                }
            }
        }
        default:
            break
    }
    return state
}